<script setup>
import dragonSushi from "@/assets/Home/dragonsushi.png";
import steakTartare from "@/assets/Home/steaktartar.png";
import creamyParmesan from "@/assets/Home/creamyParmesanChicken.png";
import sushi1 from "@/assets/Home/sushi1.jpeg";
import sushi2 from "@/assets/Home/sushi2.jpeg";
import sushi3 from "@/assets/Home/sushi3.jpeg";
import CleanupReservations from "@/components/CleanupReservations.vue";
import Card from "@/components/Card.vue";
import AlternatingImage from "@/components/AlternatingImage.vue";
import SmartChatbot from "@/components/SmartChatbot.vue";
import { ref, computed } from "vue";
import MobileCategories from "@/components/MobileCategories.vue";

import { useRouter } from 'vue-router'
const router = useRouter()

function goToAbout() {
  router.push('/aboutus')}

// Reactive data for selected category
const selectedCategory = ref("homestyle");
import { useI18n } from "vue-i18n";
const { t } = useI18n({ useScope: "global" });
const $t = t;

const catLabels = computed(() => ({
  appetizers: String($t("homepage.appetizers")),
  homestyle: String($t("homepage.homestyle")),
  steak: String($t("homepage.steak")),
  chicken: String($t("homepage.chicken")),
  beverages: String(t("homepage.beverages")),
}));

const { locale } = useI18n({ useScope: "global" });
const isRTL = computed(
  () => locale.value?.startsWith("ar") || document?.dir === "rtl"
);

// Cart management functions
const addToCart = (cartItem) => {
  const storedCart = localStorage.getItem("cart");
  let cart = storedCart ? JSON.parse(storedCart) : [];

  const existing = cart.find((item) => item.name === cartItem.name);
  if (existing) {
    existing.quantity += 1;
  } else {
    cart.push(cartItem);
  }

  localStorage.setItem("cart", JSON.stringify(cart));
};

// Category data
const categories = {
  appetizers: [
    {
      image: require("@/assets/Home/appetizer/TomatoToast.jpg"),
      titleKey: "homepage.categories.appetizers.tomatoToast.title",
      descriptionKey: "homepage.categories.appetizers.tomatoToast.description",
      priceKey: "homepage.categories.appetizers.tomatoToast.price",
    },
    {
      image: require("@/assets/Home/appetizer/NoodleSoup.jpg"),
      titleKey: "homepage.categories.appetizers.noodleSoup.title",
      descriptionKey: "homepage.categories.appetizers.noodleSoup.description",
      priceKey: "homepage.categories.appetizers.noodleSoup.price",
    },
    {
      image: require("@/assets/Home/appetizer/PumpkinSoup.png"),
      titleKey: "homepage.categories.appetizers.pumpkinSoup.title",
      descriptionKey: "homepage.categories.appetizers.pumpkinSoup.description",
      priceKey: "homepage.categories.appetizers.pumpkinSoup.price",
    },
  ],
  homestyle: [
    {
      image: sushi1,
      titleKey: "homepage.categories.homestyle.dragonSushi.title",
      descriptionKey: "homepage.categories.homestyle.dragonSushi.description",
      priceKey: "homepage.categories.homestyle.dragonSushi.price",
    },
    {
      image: sushi3,
      titleKey: "homepage.categories.homestyle.creamySushi.title",
      descriptionKey: "homepage.categories.homestyle.creamySushi.description",
      priceKey: "homepage.categories.homestyle.creamySushi.price",
    },
    {
      image: sushi2,
      titleKey: "homepage.categories.homestyle.salmonRoll.title",
      descriptionKey: "homepage.categories.homestyle.salmonRoll.description",
      priceKey: "homepage.categories.homestyle.salmonRoll.price",
    },
  ],
  steak: [
    {
      image: require("@/assets/Home/steak/SteakTartare.jpg"),
      titleKey: "homepage.categories.steak.steakTartare.title",
      descriptionKey: "homepage.categories.steak.steakTartare.description",
      priceKey: "homepage.categories.steak.steakTartare.price",
    },
    {
      image: require("@/assets/Home/steak/SurfTurf.jpg"),
      titleKey: "homepage.categories.steak.surfTurf.title",
      descriptionKey: "homepage.categories.steak.surfTurf.description",
      priceKey: "homepage.categories.steak.surfTurf.price",
    },
    {
      image: require("@/assets/Home/steak/WagyuBeef.jpg"),
      titleKey: "homepage.categories.steak.wagyuBeef.title",
      descriptionKey: "homepage.categories.steak.wagyuBeef.description",
      priceKey: "homepage.categories.steak.wagyuBeef.price",
    },
  ],
  chicken: [
    {
      image: require("@/assets/Home/chicken/CreamyParmesanChicken.jpg"),
      titleKey: "homepage.categories.chicken.creamyParmesan.title",
      descriptionKey: "homepage.categories.chicken.creamyParmesan.description",
      priceKey: "homepage.categories.chicken.creamyParmesan.price",
    },
    {
      image: require("@/assets/Home/chicken/SpringChicken.jpg"),
      titleKey: "homepage.categories.chicken.springChicken.title",
      descriptionKey: "homepage.categories.chicken.springChicken.description",
      priceKey: "homepage.categories.chicken.springChicken.price",
    },
    {
      image: require("@/assets/Home/chicken/ChickenFrancese.png"),
      titleKey: "homepage.categories.chicken.chickenFrancese.title",
      descriptionKey: "homepage.categories.chicken.chickenFrancese.description",
      priceKey: "homepage.categories.chicken.chickenFrancese.price",
    },
  ],
  beverages: [
    {
      image: require("@/assets/Home/beverages/PanthouseTonic.png"),
      titleKey: "homepage.categories.beverages.panthouseTonic.title",
      descriptionKey:
        "homepage.categories.beverages.panthouseTonic.description",
      priceKey: "homepage.categories.beverages.panthouseTonic.price",
    },
    {
      image: require("@/assets/Home/beverages/AppleBreeze.jpg"),
      titleKey: "homepage.categories.beverages.appleBreeze.title",
      descriptionKey: "homepage.categories.beverages.appleBreeze.description",
      priceKey: "homepage.categories.beverages.appleBreeze.price",
    },
    {
      image: require("@/assets/Home/beverages/FrenchmanBlitz.jpg"),
      titleKey: "homepage.categories.beverages.frenchmanBlitz.title",
      descriptionKey:
        "homepage.categories.beverages.frenchmanBlitz.description",
      priceKey: "homepage.categories.beverages.frenchmanBlitz.price",
    },
  ],
};

// Computed property to get current category items
const currentItems = computed(() => {
  return categories[selectedCategory.value] || categories.homestyle;
});

// Method to change category
const changeCategory = (category) => {
  selectedCategory.value = category;
};
</script>

<template>
  <div class="page">
    <CleanupReservations />
    <SmartChatbot />

    <!-- HERO -->
    <section
      class="relative min-h-screen flex flex-col justify-center items-center text-center px-4 overflow-hidden pt-18 md:pt-0"
    >
      <!-- Background image -->
      <div
        class="absolute inset-0 bg-cover bg-center opacity-85 z-0"
        :style="{
          backgroundImage: `url(${require('@/assets/Home/cover.jpeg')})`,
        }"
      ></div>

      <!-- Themed gradient overlay -->
      <div class="absolute inset-0 hero-overlay z-0"></div>

      <!-- Content -->
      <div
        class="px-2 sm:px-6 md:px-2 max-w-5xl mx-auto text-cente relative z-10"
      >
        <h2
          class="text-base sm:text-lg md:text-2xl mb-4 tracking-[0.3em] font-light text-on-surface"
          style="font-family: 'Great Vibes', cursive"
        >
          {{ $t("homepage.welcome") }}
        </h2>

        <h1
          class="text-2xl sm:text-3xl md:text-3xl lg:text-4xl text-primary font-extrabold mb-8 drop-shadow-lg"
          style="font-family: 'Cinzel', serif"
        >
          {{ $t("homepage.explore") }}
        </h1>

        <router-link to="/menu">
          <button
            class="px-8 py-3 text-xs sm:text-base md:text-lg font-semibold btn-solid-primary"
            style="font-family: 'Cormorant SC', serif; border-radius: 0"
          >
            {{ $t("homepage.gotoMenu") }}
          </button>
        </router-link>
      </div>
    </section>

    <!-- TODAY'S SPECIAL -->
    <section class="py-20 text-center px-4 sm:px-6 md:px-8">
      <h3
        class="text-sm sm:text-base md:text-lg font-light text-on-surface"
        style="font-family: 'Great Vibes', cursive"
      >
        {{ $t("homepage.specialMenus") }}
      </h3>

      <h2
        class="mt-4 text-lg sm:text-2xl md:text-4xl text-primary-200"
        style="font-family: 'Cormorant SC', serif"
      >
        {{ $t("homepage.todaysSpecial") }}
      </h2>

      <h3
        class="mt-2 text-xs sm:text-base md:text-lg text-on-surface font-normal leading-relaxed"
        style="font-family: 'DM Sans', sans-serif"
      >
        {{ $t("homepage.specialDesc") }}
      </h3>
    </section>

    <!-- CARDS -->
    <section class="py-2 flex justify-center items-center">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 w-full max-w-6xl px-4">
        <Card
          :image="dragonSushi"
          :title="$t('homepage.dishes.dragonSushiTitle')"
          :description="$t('homepage.dishes.dragonSushiDesc')"
          :buttonLabel="$t('homepage.orderNow')"
          :titleKey="'homepage.categories.homestyle.dragonSushi.title'"
          :addToCart="addToCart"
        />
        <Card
          :image="steakTartare"
          :title="$t('homepage.dishes.steakTartareTitle')"
          :description="$t('homepage.dishes.steakTartareDesc')"
          :buttonLabel="$t('homepage.orderNow')"
          :titleKey="'homepage.categories.steak.steakTartare.title'"
          :addToCart="addToCart"
        />
        <Card
          :image="creamyParmesan"
          :title="$t('homepage.dishes.creamyParmesanTitle')"
          :description="$t('homepage.dishes.creamyParmesanDesc')"
          :buttonLabel="$t('homepage.orderNow')"
          :titleKey="'homepage.categories.chicken.creamyParmesan.title'"
          :addToCart="addToCart"
        />
        <Card
          :image="sushi2"
          :title="$t('homepage.dishes.salmonRollTitle')"
          :description="$t('homepage.dishes.salmonRollDesc')"
          :buttonLabel="$t('homepage.orderNow')"
          :titleKey="'homepage.categories.homestyle.salmonRoll.title'"
          :addToCart="addToCart"
        />
      </div>
    </section>

    <!-- FEATURED IMAGE -->
    <section class="py-20">
      <div class="overlay-wrap w-full max-w-full shadow-lg">
        <img
          src="@/assets/Home/ImageDevider.png"
          alt=""
          class="w-full max-w-full block"
        />
      </div>
    </section>

    <!-- MENU CATEGORY -->
    <section class="py-8 text-center">
      <h3
        class="text-xs sm:text-base md:text-lg font-light text-on-surface"
        style="font-family: 'Great Vibes', cursive; letter-spacing: 0.3em"
      >
        {{ $t("homepage.quality") }}
      </h3>

      <h2
        class="mt-4 text-lg sm:text-2xl md:text-4xl text-primary-200"
        style="font-family: 'DM Serif Display', serif"
      >
        {{ $t("homepage.ourMenu") }}
      </h2>

      <h3
        class="text-xs sm:text-base md:text-lg text-on-surface"
        style="font-family: 'DM Sans', serif"
      >
        {{ $t("homepage.authentic") }}
      </h3>
    </section>

    <!-- CATEGORY BUTTONS -->
    <section
      class="hidden md:flex justify-center items-center py-8 px-4 sm:px-12 md:px-24"
    >
      <div class="flex flex-wrap gap-4 justify-center w-full">
        <button
          @click="changeCategory('appetizers')"
          :class="['chip', { 'is-active': selectedCategory === 'appetizers' }]"
          style="font-family: 'DM Sans', sans-serif; border-radius: 0"
        >
          {{ $t("homepage.appetizers") }}
        </button>

        <button
          @click="changeCategory('homestyle')"
          :class="['chip', { 'is-active': selectedCategory === 'homestyle' }]"
          style="font-family: 'DM Sans', sans-serif; border-radius: 0"
        >
          {{ $t("homepage.homestyle") }}
        </button>

        <button
          @click="changeCategory('steak')"
          :class="['chip', { 'is-active': selectedCategory === 'steak' }]"
          style="font-family: 'DM Sans', sans-serif; border-radius: 0"
        >
          {{ $t("homepage.steak") }}
        </button>

        <button
          @click="changeCategory('chicken')"
          :class="['chip', { 'is-active': selectedCategory === 'chicken' }]"
          style="font-family: 'DM Sans', sans-serif; border-radius: 0"
        >
          {{ $t("homepage.chicken") }}
        </button>

        <button
          @click="changeCategory('beverages')"
          :class="['chip', { 'is-active': selectedCategory === 'beverages' }]"
          style="font-family: 'DM Sans', sans-serif; border-radius: 0"
        >
          {{ $t("homepage.beverages") }}
        </button>
      </div>
    </section>

    <!-- MOBILE: new tabs + snap carousel -->
    <MobileCategories
      class="md:hidden"
      :categories="categories"
      :selected-category="selectedCategory"
      :add-to-cart="addToCart"
      :labels="catLabels"
      :is-rtl="isRTL"
      @update:selectedCategory="(v) => (selectedCategory = v)"
    />

    <!-- DESKTOP/TABLET: Alternating sections only -->
    <div class="hidden md:block">
      <AlternatingImage
        :image="currentItems[0].image"
        :title="$t(currentItems[0].titleKey)"
        :description="$t(currentItems[0].descriptionKey)"
        :price="$t(currentItems[0].priceKey)"
      />
      <AlternatingImage
        :image="currentItems[1].image"
        :title="$t(currentItems[1].titleKey)"
        :description="$t(currentItems[1].descriptionKey)"
        :price="$t(currentItems[1].priceKey)"
        :reverse="true"
      />
      <AlternatingImage
        :image="currentItems[2].image"
        :title="$t(currentItems[2].titleKey)"
        :description="$t(currentItems[2].descriptionKey)"
        :price="$t(currentItems[2].priceKey)"
      />
    </div>

    <!-- IMAGE BANNER -->
    <section class="py-10">
      <img
        src="@/assets/Home/ImageDevider2.jpeg"
        alt=""
        class="w-full max-w-fullshadow-lg h-40 sm:h-56 md:h-72 lg:h-[363px] object-cover"
      />
    </section>

    <!-- ABOUT -->
    <section class="py-8 text-center">
      <h3
        class="text-xs sm:text-base md:text-lg font-light text-on-surface"
        style="font-family: 'Great Vibes', cursive; letter-spacing: 0.3em"
      >
        {{ $t("homepage.about") }}
      </h3>

      <h2
        class="mt-4 text-lg sm:text-2xl md:text-4xl text-primary-200"
        style="font-family: 'DM Serif Display', serif"
      >
        {{ $t("homepage.story") }}
      </h2>

      <h3
        class="text-xs sm:text-base md:text-lg text-on-surface"
        style="font-family: 'DM Sans', sans-serif"
      >
        {{ $t("homepage.journey") }}
      </h3>
    </section>

    <!-- WHY CHOOSE US -->
    <section
      class="flex flex-col md:flex-row items-center max-w-5xl mx-auto gap-8 py-8 min-h-[500px]"
    >
      <img
        src="@/assets/Home/Frame 29.png"
        alt="About Photo"
        class="w-full md:w-1/2 h-[420px] object-cover rounded-lg shadow-lg mb-6 md:mb-0"
      />
      <div
        class="flex-1 bg-surface rounded-lg p-12 shadow-lg flex flex-col justify-center min-h-[420px] text-on-surface"
      >
        <h4
          class="text-base sm:text-lg md:text-2xl font-bold mb-2 text-primary"
          style="font-family: 'Cormorant SC', serif"
        >
          {{ $t("homepage.whyChoose") }}
        </h4>
        <p class="mb-2 text-xs sm:text-base md:text-lg">
          {{ $t("homepage.whyDesc") }}
        </p>
        <button
        @click="goToAbout"
          class="mt-4 px-5 py-2 text-xs sm:text-base md:text-lg font-semibold btn-outline-primary"
          style="font-family: 'Cormorant SC', serif; border-radius: 0"
        >
          {{ $t("homepage.moreAbout") }}
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
/* page shell */
.page {
  background: var(--bg);
  color: var(--text);
}

/* HERO overlay sits above the bg image */
.hero-overlay {
  background: var(--hero-overlay);
}

/* Divider: overlay above the <img> using ::after */
.overlay-wrap {
  position: relative;
}
.overlay-wrap::after {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--image-overlay);
  pointer-events: none;
}

/* text helpers */
.text-on-surface {
  color: var(--on-surface);
}
.text-primary {
  color: var(--primary);
}
.text-primary-200 {
  color: var(--primary-200);
}

/* surfaces */
.bg-surface {
  background: var(--surface);
}

/* buttons */
.btn-solid-primary {
  background: var(--primary);
  color: var(--on-primary);
  border: none;
  box-shadow: var(--glow-sm);
  transition: filter 0.2s ease;
}
.btn-solid-primary:hover {
  filter: brightness(1.03);
}

.btn-outline-primary {
  color: var(--primary);
  border: 1px solid var(--primary);
  background: transparent;
  box-shadow: var(--glow-sm);
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}
.btn-outline-primary:hover {
  background: var(--primary);
  color: var(--on-primary);
}

/* category chips */
.chip {
  padding: 0.5rem 1.5rem;
  font-weight: 400;
  font-size: clamp(0.75rem, 2vw, 1.125rem);
  border: 1px solid var(--chip-border);
  color: var(--chip-text);
  background: transparent;
  transition: background 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}
.chip:hover {
  background: var(--primary);
  color: var(--on-primary);
  border-color: var(--primary);
  box-shadow: var(--glow-sm);
}
.chip.is-active {
  background: var(--chip-bg-active);
  color: var(--chip-text-active);
  border-color: var(--primary);
  box-shadow: var(--glow-sm);
}
</style>
